import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-reset-application-dialog',
  templateUrl: './reset-application-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ResetApplicationDialogComponent {
  constructor(
    public matDialogRef: MatDialogRef<ResetApplicationDialogComponent>,
  ) {}

  public cancelClicked() {
    this.matDialogRef.close(false);
  }

  public submitClicked() {
    this.matDialogRef.close(true);
  }
}
